import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/networks/$networkId/details/')({
  component: NetworkDetailsIndexRoute,
});

function NetworkDetailsIndexRoute() {
  const { networkId } = Route.useParams();
  return <Navigate to="/networks/$networkId/details/overview" params={{ networkId }} replace />;
}
